import { SyntheticEvent } from 'react'

export function useGetDeletePreset(onPresetDelete: () => void) {
	return function (e: SyntheticEvent) {
		e.stopPropagation()
		onPresetDelete()
	}
}
